import React from 'react'
import { 
    Outer,
    Icon,
    Title,
    Lower,
    Page,
    Left
} from './UIElements'
import logo from '../img/logo.png'
import account from '../svg/account.svg'
import { Link } from 'react-router-dom'

export default function UI({
    open,
    loggedIn,
    renderer,
    setRenderer,
    size,
    affiliate
}) {
    
    return (
        <>
        <Outer open={open} loggedIn={loggedIn}>
            
            {/* Left */}
            <Left>
            <Icon src={logo} onClick={() => window.location = (loggedIn ? '/new':'/')}/>
            <Title onClick={() => window.location = (loggedIn ? '/new':'/')}>Stormy</Title>
            {loggedIn && size.width > 510 ?
            <>
                <Link to='/new'>New</Link>
                <Link to='/history'>History</Link>
            </>
            : null}

            {/* Link to affiliate page for eligible users */}
            {loggedIn && affiliate !== null ?
            <Link to='/affiliate'>Affiliate</Link>
            : null}

            </Left>

            {/* Right */}
            {loggedIn ?
            <Icon src={account} onClick={() => window.location = '/account'}/>
            : null}
            
        </Outer>
        
        {loggedIn && size.width <= 510?
        <Lower>
            {/* Scripter */}
            <Page selected={window.location.pathname==='/new'}>
                <Link to='/new' onClick={() => setRenderer(renderer + 1)}>
                    New
                </Link>
            </Page>

            {/* Saved */}
            <Page selected={window.location.pathname==='/saved'}>
                <Link to='/history' onClick={() => setRenderer(renderer + 1)}>
                    History
                </Link>
            </Page>
        </Lower>
        : null}
    </>
    );
}